"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessCalculations = void 0;
const RetentionCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionCalculations");
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const lodash_1 = __importDefault(require("lodash"));
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const ICEventQueryUtil_1 = require("src/hello_assets/src/util/ICEventQueryUtil");
const CommonTypesI18N_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesI18N");
const calculateClassicSeries = (params) => {
    if (!!process.env.IS_TEST_SERVER) {
        console.log("stickiness calculateClassicSeries: start with", params);
    }
    const calculateClassicSeriesStart = performance.now();
    const request = params.request;
    const retention = params.response.chartData;
    const chartSeries = [];
    const cohortName = ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariants(request.cohortQuery);
    const returnName = ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariants(request.returnQuery);
    // const isCumulative = params.lineType === LineType.cumulative
    // const retentionType: RetentionType = CommonTypesConversions.retentionType.retentionTypeTypeToRetentionType("nDay")
    const cohortCheckEndDays = 0;
    const initialDateMillis = params.response.intervalStartTimeSec * 1000;
    const initialMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(initialDateMillis).startOf("day");
    const currentDayMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDay();
    const retentionPeriods = params.response.periods;
    // const seriesNamePrefix = isCumulative ?
    //     `${cohortName} ${CommonTypesI18N.constants.highchartsArrow} ${returnName} ${getPeriodNamePrefix(true)}X Days Out Of ${retentionPeriods.length}` :
    //     `${cohortName} ${CommonTypesI18N.constants.highchartsArrow} ${returnName} X Days Out Of ${retentionPeriods.length}`;
    const seriesNamePrefix = `${cohortName} ${CommonTypesI18N_1.CommonTypesI18N.constants.highchartsArrow} ${returnName} ${getPeriodNamePrefix(params.lineType === "cumulative")}X Days Out Of ${retentionPeriods.length}`;
    const sortingIndex = 0;
    //на classic выбираем "avg" и среди дат
    const isAvgEnabled = params.filterCohortDays.avg;
    if (isAvgEnabled) {
        let maxPeriods = 0;
        let avgCohortSizeTotal = 0;
        let avgCohortCounter = 0;
        let incompleteDataCalculatedAvg = false;
        if (retention) {
            for (let rowIndex = 0; rowIndex < retention.length; rowIndex++) {
                if (retention[rowIndex] && retention[rowIndex].length > maxPeriods) {
                    maxPeriods = retention[rowIndex].length;
                }
                if (retention[rowIndex] && retention[rowIndex].length > 0) {
                    const allDataLoadedAvg = RetentionCalculations_1.RetentionCalculations.isCohortComplete(initialDateMillis, rowIndex, cohortCheckEndDays);
                    // console.log(`allDataLoadedAvg[${rowIndex}]`, allDataLoadedAvg);
                    if (incompleteDataCalculatedAvg || allDataLoadedAvg) {
                        avgCohortSizeTotal += retention[rowIndex][0];
                        // console.log(`1: avgCohortSizeTotal[${rowIndex}] now is `, avgCohortSizeTotal, "using", retention[rowIndex]);
                        avgCohortCounter++;
                    }
                    else if (avgCohortSizeTotal === 0) {
                        avgCohortSizeTotal += retention[rowIndex][0];
                        // console.log(`2: avgCohortSizeTotal[${rowIndex}] now is `, avgCohortSizeTotal, "using", retention[rowIndex]);
                        avgCohortCounter++;
                        incompleteDataCalculatedAvg = true;
                    }
                }
            }
        }
        // console.log("avgCohortSizeTotal", avgCohortSizeTotal, "avgCohortCounter", avgCohortCounter);
        const seriesDataAvailabilityStates = [];
        const avgData = [];
        const retentionSizes = [];
        const totalCohortSizes = [];
        const significantRetentionCounts = [];
        for (let retentionPeriodAvg = 1; retentionPeriodAvg < maxPeriods; retentionPeriodAvg++) {
            // const periodDay = params.response.periods[retentionPeriodAvg - 1];
            let totalCohortSize = 0;
            let totalRetentionSize = 0;
            let significantRetentionCount = 0;
            let incompleteDataCalculated = false;
            for (let avgRowIndex = 0; avgRowIndex < retention.length; avgRowIndex++) {
                let nextPeriodData = retention[avgRowIndex];
                if (nextPeriodData && nextPeriodData.length > 0 && nextPeriodData[0] > 0 && retentionPeriodAvg < nextPeriodData.length) {
                    const fullCohortLoaded = RetentionCalculations_1.RetentionCalculations.isCohortComplete(initialDateMillis, avgRowIndex, cohortCheckEndDays);
                    // console.log(`nextPeriodData[${avgRowIndex}]`, nextPeriodData);
                    // console.log(`allDataLoaded[avgRowIndex=${avgRowIndex}, retentionPeriodAvg=${retentionPeriodAvg}, periodDay=${periodDay}]`, allDataLoaded, "incompleteDataCalculated", incompleteDataCalculated, "fullCohortLoaded", fullCohortLoaded, "fullPeriodLoaded", fullPeriodLoaded, "nextPeriodData", nextPeriodData);
                    if (incompleteDataCalculated || fullCohortLoaded) {
                        totalCohortSize += nextPeriodData[0];
                        totalRetentionSize += nextPeriodData[retentionPeriodAvg];
                        significantRetentionCount++;
                        // console.log(`nextPeriodData[${avgRowIndex}] (incompleteDataCalculated || allDataLoaded)`, `add nextPeriodData[0]=${nextPeriodData[0]} to totalCohortSize`, `add nextPeriodData[${retentionPeriodAvg}]=${nextPeriodData[retentionPeriodAvg]} to totalRetentionSize`);
                    }
                    else if (totalCohortSize === 0) {
                        totalCohortSize += nextPeriodData[0];
                        totalRetentionSize += nextPeriodData[retentionPeriodAvg];
                        significantRetentionCount++;
                        // console.log(`nextPeriodData[${avgRowIndex}] (totalCohortSize === 0)`, `add nextPeriodData[0]=${nextPeriodData[0]} to totalCohortSize`, `add nextPeriodData[${retentionPeriodAvg}]=${nextPeriodData[retentionPeriodAvg]} to totalRetentionSize`);
                        incompleteDataCalculated = true;
                    }
                }
            }
            // console.log(`totalCohortSize[${retentionPeriodAvg}]`, totalCohortSize, "totalRetentionSize", totalRetentionSize);
            if (totalCohortSize > 0) {
                let avgValue;
                retentionSizes.push(totalRetentionSize);
                totalCohortSizes.push(totalCohortSize);
                significantRetentionCounts.push(significantRetentionCount);
                if (totalRetentionSize > 0) {
                    avgValue = parseFloat((totalRetentionSize / totalCohortSize * 100).toFixed(2));
                }
                else {
                    avgValue = 0;
                }
                if (incompleteDataCalculated) {
                    avgData.push({ y: avgValue });
                    seriesDataAvailabilityStates.push("incomplete");
                }
                else {
                    avgData.push({ y: avgValue });
                    seriesDataAvailabilityStates.push("complete");
                }
            }
        }
        if (avgData.length > 0) {
            (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataIncompleteMarkers)(avgData, seriesDataAvailabilityStates, chartSeries.length);
            let avgCohort;
            if (avgCohortSizeTotal === 0 || avgCohortCounter === 0) {
                avgCohort = 0;
            }
            else {
                avgCohort = parseInt((avgCohortSizeTotal / avgCohortCounter).toFixed(0));
            }
            const seriesName = `${seriesNamePrefix}, AVG`;
            const item = {
                color: (0, HighchartsCalculationsCommonUtils_1.getSeriesColorFromGlobalColors)(sortingIndex),
                type: 'spline',
                name: seriesName,
                custom: {
                    isAvg: true,
                    index: sortingIndex + 1,
                    cohortSize: avgCohort,
                    retentionSizes: retentionSizes,
                    totalCohortSizes: totalCohortSizes,
                    significantRetentionCounts: significantRetentionCounts
                },
                data: avgData
            };
            chartSeries.push(item);
        }
    }
    /**
     * params.filterCohortDays.daysShift приходят как дневной сдвиг от от "initialDateMillis"
     */
    const selectedDaysIndexes = params.filterCohortDays.daysShift.map(value => value);
    const allDaysIndexes = lodash_1.default.range(retention.length).map(value => value);
    lodash_1.default.each(allDaysIndexes, selectedRowIndex => {
        const selectedDayMoment = initialMoment.clone().add(selectedRowIndex, "day");
        const isCurrentDayAfter = currentDayMoment.isAfter(selectedDayMoment, "day");
        const dashStyle = isCurrentDayAfter ? "Solid" : "Dot";
        const periodName = selectedDayMoment.format(DateTimeFacade_1.DateTimeFormatByFunctionality.HumanReadable.Common.DateOnly); //periodDaysModelDays[selectedRowIndex]
        if (retention && selectedRowIndex < retention.length && retention[selectedRowIndex][0] > 0) {
            const dayData = retention[selectedRowIndex];
            const cohortSize = dayData[0];
            const periodData = [];
            const retentionSizes = [];
            const seriesDataAvailabilityStates = [];
            for (let retentionPeriodIndex = 1; retentionPeriodIndex < dayData.length; retentionPeriodIndex++) {
                const retentionSize = dayData[retentionPeriodIndex];
                retentionSizes.push(retentionSize);
                const value = parseFloat((retentionSize / cohortSize * 100).toFixed(2));
                if (isCurrentDayAfter) {
                    periodData.push({ y: value });
                    seriesDataAvailabilityStates.push("complete");
                }
                else {
                    periodData.push({ y: value });
                    seriesDataAvailabilityStates.push("incomplete");
                }
            }
            if (periodData.length > 0) {
                (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataIncompleteMarkers)(periodData, seriesDataAvailabilityStates, chartSeries.length);
                const seriesColor = (0, HighchartsCalculationsCommonUtils_1.getSeriesColorFromGlobalColors)(chartSeries.length);
                const seriesName = `${seriesNamePrefix}, ${periodName}`;
                const item = {
                    dashStyle: dashStyle,
                    color: seriesColor,
                    type: 'spline',
                    name: seriesName,
                    custom: {
                        isAvg: false,
                        index: sortingIndex + 1,
                        cohortSize: cohortSize,
                        retentionSizes: retentionSizes,
                        date: periodName,
                        dayShift: selectedRowIndex
                    },
                    data: periodData,
                    visible: lodash_1.default.includes(selectedDaysIndexes, selectedRowIndex),
                    showInLegend: lodash_1.default.includes(selectedDaysIndexes, selectedRowIndex)
                };
                chartSeries.push(item);
            }
        }
    });
    const calculateClassicSeriesDuration = Number.parseFloat((performance.now() - calculateClassicSeriesStart).toFixed(2));
    if (!!process.env.IS_TEST_SERVER) {
        console.log(`stickiness calculateClassicSeries in ${calculateClassicSeriesDuration}ms`);
    }
    return chartSeries;
};
const calculateOvertimeSeries = (params) => {
    if (!!process.env.IS_TEST_SERVER) {
        console.log("stickiness calculateOvertimeSeries: start with", params);
    }
    const calculateOvertimeSeriesStart = performance.now();
    const request = params.request;
    const retention = params.response.chartData;
    const retentionPeriods = params.response.periods;
    const isCumulative = params.lineType === LineTypeJSONModel_1.LineType.cumulative;
    const cohortName = ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariants(request.cohortQuery);
    const returnName = ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariants(request.returnQuery);
    const seriesNamePrefix = `${cohortName} ${CommonTypesI18N_1.CommonTypesI18N.constants.highchartsArrow} ${returnName}`;
    const initialMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(params.response.intervalStartTimeSec * 1000).startOf("day");
    const currentDayMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDay();
    //на overtime выбираем из [1,2,3,4,5,6,7]
    const overtimePeriods = params.filterFrequency;
    // if (process.env.NODE_ENV === "development") {
    //     overtimePeriods = [1,2,3,4,5,6,7]
    // }
    const chartSeries = [];
    if (!lodash_1.default.isEmpty(retentionPeriods)) {
        for (let selectedRetentionPeriodIndexNew = 0; selectedRetentionPeriodIndexNew < retentionPeriods.length; selectedRetentionPeriodIndexNew++) {
            const currentRetentionPeriod = retentionPeriods[selectedRetentionPeriodIndexNew];
            const seriesDataAvailabilityStates = [];
            const zones = [];
            const data = [];
            const retentionSizes = [];
            const cohortSizes = [];
            let shouldShowCurrentPeriod = lodash_1.default.includes(overtimePeriods, currentRetentionPeriod);
            if (retention && shouldShowCurrentPeriod) {
                // console.log(`currentRetentionPeriod[${selectedRetentionPeriodIndexNew}]`, currentRetentionPeriod);
                for (let rowIndex = 0; rowIndex < retention.length; rowIndex++) {
                    const dayData = retention[rowIndex];
                    // console.log(`day with shift`,data.length,  initialMoment.clone().add(data.length, "day").toDate(), "selectedRetentionPeriodIndexNew" ,selectedRetentionPeriodIndexNew, `dayData[${rowIndex}].length`,dayData.length);
                    const currentPointMoment = initialMoment.clone().add(data.length, "day");
                    const pointMillis = currentPointMoment.valueOf();
                    if (selectedRetentionPeriodIndexNew < dayData.length - 1) {
                        // console.log(`dayData[selectedRetentionPeriodIndexNew=${selectedRetentionPeriodIndexNew},rowIndex=${rowIndex}] data`, dayData)
                        const cohortSize = dayData[0];
                        const retentionSize = dayData[selectedRetentionPeriodIndexNew + 1];
                        retentionSizes.push(retentionSize);
                        cohortSizes.push(cohortSize);
                        let value;
                        if (retentionSize > 0 && cohortSize > 0) {
                            value = parseFloat((retentionSize / cohortSize * 100).toFixed(2));
                        }
                        else {
                            value = parseFloat((0).toFixed(2));
                        }
                        const isCurrentDayAfter = currentDayMoment.isAfter(currentPointMoment, "day");
                        if (isCurrentDayAfter) {
                            data.push({ x: pointMillis, y: value });
                            zones.push({ value: pointMillis, dashStyle: "Solid" });
                            seriesDataAvailabilityStates.push("complete");
                        }
                        else {
                            data.push({ x: pointMillis, y: value });
                            zones.push({ value: pointMillis, dashStyle: "Dot" });
                            seriesDataAvailabilityStates.push("incomplete");
                        }
                    }
                    else {
                        retentionSizes.push(null);
                        cohortSizes.push(null);
                        const noDataValue = parseFloat((0).toFixed(2));
                        // console.log(`dayData[selectedRetentionPeriodIndexNew=${selectedRetentionPeriodIndexNew},rowIndex=${rowIndex}] noDataValue`, noDataValue)
                        data.push({ x: pointMillis, y: noDataValue });
                    }
                }
            }
            if (data.length > 0) {
                (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataIncompleteMarkers)(data, seriesDataAvailabilityStates, chartSeries.length);
                const seriesColor = (0, HighchartsCalculationsCommonUtils_1.getSeriesColorFromGlobalColors)(chartSeries.length);
                const periodName = getPeriodName(isCumulative, currentRetentionPeriod, retentionPeriods.length, "");
                const seriesName = `${seriesNamePrefix} ${periodName} Days`;
                chartSeries.push({
                    type: 'spline',
                    color: seriesColor,
                    name: seriesName,
                    custom: {
                        day: currentRetentionPeriod,
                        periodValue: currentRetentionPeriod,
                        periodLength: retentionPeriods.length,
                        cohortSizes: cohortSizes,
                        retentionSizes: retentionSizes,
                    },
                    data: data,
                    zoneAxis: 'x',
                    zones: (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesZones)(zones),
                    visible: true, //chartSeries.length < 8,
                });
            }
        }
    }
    const calculateOvertimeSeriesDuration = Number.parseFloat((performance.now() - calculateOvertimeSeriesStart).toFixed(2));
    if (!!process.env.IS_TEST_SERVER) {
        console.log(`stickiness calculateOvertimeSeries in ${calculateOvertimeSeriesDuration}ms`);
    }
    // if (process.env.NODE_ENV === "development") {
    //     console.log("chartSeries", chartSeries);
    // }
    return chartSeries;
};
const getPeriodName = function (isCumulative, value, length, spacer = "") {
    const prefix = getPeriodNamePrefix(isCumulative);
    return `${prefix}${spacer}${value}/${length}`;
};
const getPeriodNamePrefix = function (isCumulative) {
    if (isCumulative) {
        return `≥`;
    }
    else {
        return ``;
    }
};
exports.StickinessCalculations = {
    calculateClassicSeries,
    calculateOvertimeSeries,
    getPeriodName
};
